@if (fileList().length > 0) {
  <ul class="ant-upload-list">
    <li>
      @for (file of fileList(); track file.uid) {
        @if (file.type?.startsWith('image/')) {
          <nz-icon nzType="file-image" class="thumb-icon"></nz-icon>
        } @else if (file.type === 'application/pdf') {
          <nz-icon nzType="file-pdf" class="thumb-icon"></nz-icon>
        } @else {
          <nz-icon nzType="file" class="thumb-icon"></nz-icon>
        }

        <div class="file-info">
          @if (file?.url) {
            <button type="button" (click)="downloadFile.emit(file)">
              {{ file.name }}
            </button>
          } @else {
            <span>
              {{ file.name }}
            </span>
          }

          <small> {{ file.size | formatFileSize }} </small>
        </div>

        <div class="progress">
          @if (file.status === 'uploading') {
            <nz-progress
              [nzPercent]="file.percent"
              [nzShowInfo]="false"
            ></nz-progress>
          }
        </div>

        @if (!isDisabled()) {
          @if (file?.url || file.status !== 'uploading') {
            <moxi-confirmation-button
              size="small"
              shape="circle"
              icon="close"
              type="text"
              confirmText="Do you really want to delete this file?"
              [tooltip]="'global.delete' | translate"
              [danger]="true"
              (confirm)="removeFile.emit(file)"
            />
          }
        }
      }
    </li>
  </ul>
}
